import { render, staticRenderFns } from "./idxContact.vue?vue&type=template&id=0bad06b1&"
import script from "./idxContact.vue?vue&type=script&lang=js&"
export * from "./idxContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports